module.exports = __webpack_public_path__ + "static/media/UniParis_logo.5e7a024a.webp";